import * as React from 'react';
import {RegistrationMethodsScreenType} from '@practicegenius/register-account/src/screens/RegistrationMethods';
import {SecureHtml} from '@practicegenius/pg-ui/src/base/SecureHtml';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import {ProgressScreen} from '../../../components/screens/BaseScreen';
import {Button} from '../../../components/Button';
import {loginBottomText} from '../components/layout';
import {useSocialOauth} from '../../../screens/social-auth/SocialOauth';
import {LoginSupportFooter} from '../../../components/LoginSupportFooter';

type SupportedPlatform =
  keyof React.ComponentProps<RegistrationMethodsScreenType>['socialLogin'];
type SocialAuthButtonProps =
  React.ComponentProps<RegistrationMethodsScreenType>['socialLogin'][SupportedPlatform] & {
    platform: SupportedPlatform;
  };

const SocialAuthButton = ({
  label,
  ...socialOauthProps
}: SocialAuthButtonProps) => {
  const {startAuth, disabled} = useSocialOauth({
    ...socialOauthProps,
    authPopupUrl: socialOauthProps.targetUrl,
  });

  return (
    <Button
      btnStyle={socialOauthProps.platform}
      onClick={startAuth}
      disabled={disabled}
    >
      Continue With {label}
    </Button>
  );
};

export const RegistrationMethods: RegistrationMethodsScreenType = ({
  lang,
  progress,
  instructions,
  socialLogin,
  continueWithEmailButtonProps,
}) => {
  const socialLogins = Object.entries(socialLogin);
  return (
    <ProgressScreen
      helmetTitle={lang.pageTitle}
      progress={progress}
      headerTitle={lang.headerTitle}
      title={lang.title}
      instructions={<SecureHtml component="span" html={instructions} />}
      bottomText={
        <>
          {loginBottomText}
          <LoginSupportFooter />
        </>
      }
      cancelProps={{href: '/'}}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Box
          sx={{
            width: '300px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Button
            onClick={continueWithEmailButtonProps.onClick}
            btnStyle="email"
            style={{margin: 0}}
          >
            Continue With Email
          </Button>
          {socialLogins.length > 0 && (
            <>
              <Divider
                sx={{
                  width: '100%',
                  my: 1,
                }}
              >
                {lang.dividerText}
              </Divider>
              {socialLogins.map(([platform, authProps]) => (
                <SocialAuthButton
                  key={platform}
                  platform={platform as SupportedPlatform}
                  {...authProps}
                />
              ))}
            </>
          )}
        </Box>
      </Box>
    </ProgressScreen>
  );
};
